export default __webpack_public_path__ + "static/media/bookmark_icon.fc1daf17.svg";